import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/risk-assessment/$id')({
  component: () => <Outlet />,
});
